import { Component, input } from '@angular/core';
import { WinCardSixthVariantConfig } from '@shared/models';
import { RewardPipe, SafePipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant6',
  imports: [RewardPipe, SafePipe],
  styleUrl: './variant6.component.scss',
  templateUrl: './variant6.component.html',
})
export class Variant6Component {
  amount = input<number>(0);
  config = input.required<WinCardSixthVariantConfig>();
}
